import { DateOnly } from '@sevenrooms/timepiece'
import type { UserPreference, UserSignificantDate } from '@sevenrooms/ui-kit/core'

export function mapPreferencesToTags(preferences: UserPreference[], dietaryPreferenceTags: Record<string, string>) {
  const keys = Object.keys(dietaryPreferenceTags)
  return preferences
    .map(({ preferenceValue }) => keys.find(key => key.endsWith(`##${preferenceValue}`)))
    .filter((k): k is string => k !== undefined)
}

export function mapSignificantDaysToTags(
  resDate: string,
  significantDates: UserSignificantDate[] | undefined,
  tags: Record<string, string>
) {
  const resDateOnly = DateOnly.fromSafe(resDate)
  if (resDateOnly) {
    const days = ['birthday', 'anniversary'] as const
    return days
      .map(preferenceValue => {
        const [month, day] = getDayParts(significantDates, preferenceValue)
        if (resDateOnly.getInfo().day === Number(day) && resDateOnly.getInfo().month + 1 === Number(month)) {
          return Object.keys(tags).find(key => key.toLowerCase().endsWith(`##${preferenceValue.toLowerCase()}`))
        }
        return undefined
      })
      .filter(value => !!value) as string[]
  }
  return []
}

function adjustToDateString(value: number) {
  if (value < 10) {
    return `0${value}`
  }
  return `${value}`
}

export const getDayParts = (significantDates?: UserSignificantDate[], dateType?: 'birthday' | 'anniversary') => {
  const dateUtc = significantDates?.find(date => date.dateType === dateType)?.dateUtc
  const dateOnly = DateOnly.fromSafe(dateUtc)
  if (!dateOnly) {
    return [undefined, undefined]
  }
  const month = dateOnly.toJsDate().getMonth() + 1
  const day = dateOnly.toJsDate().getDate()
  return [adjustToDateString(month), adjustToDateString(day)]
}
